/**
 * 模块名称: 待结算列表 => 退款订单列表页 => 结算弹窗
 * @author liujingxue@372163.com
 */

import React, { useState, useRef } from 'react'
import api from '@/api'
import {
	Form,
	Icon,
	Upload,
	DatePicker,
} from 'antd'
import { upLoadModule } from '@/utils/common'
import BtnGroup from '@/components/BtnGroup'
import moment from 'moment'

const { Dragger } = Upload
const FormItem = Form.Item
const dateFormat = 'YYYY-MM-DD'

const ClosingModal = (props) => {
	const { closing, setVisibleClosing, getEmployeeList } = props
	const { getFieldDecorator, validateFields } = props.form
	const draggerRef = useRef(null)
	const [fileList, setFileList] = useState([])

	const formSubmit = (e) => {
		e.preventDefault()
		validateFields((err, vals) => {
			let uploadList = []
			for (let i = 0, k = fileList.length; i < k; i++) {
				if (fileList[i].status !== 'removed') {
					uploadList.push({
						url: fileList[i].url,
						name: fileList[i].name
					})
				}
			}
			if (!err) {
				let submitValues = { ...vals }
				submitValues.payTime = submitValues.payTime.format(dateFormat)
				api.setInnerFundTransferClose({
					id: closing.id,
					proof: uploadList,
					...submitValues
				}).then(res => {
					setVisibleClosing(false)
					getEmployeeList()
				}).catch(err => console.log(err))
			}
		})
	}

	// 文件上传 
	const uploadFiles = upLoadModule({
		fileList: fileList,
		setFileList: setFileList,
		draggerRef: draggerRef,
		accept: '.png, .jpg, .PDF',
		allowSizeType: 2
	})

	const formItemLayout = {
		labelCol: {
			span: 6
		},
		wrapperCol: {
			span: 18
		}
	}

	return (
		<Form onSubmit={formSubmit} {...formItemLayout}>
			<FormItem label="业务编号">
				<div>{closing.id}</div>
			</FormItem>
			<FormItem label="转款金额">
				<div>{closing.money}</div>
			</FormItem>
			<FormItem label="公司主体">
				<div>{closing.fromCompanyName}</div>
			</FormItem>
			<FormItem label="收款单位">
				<div>{closing.toCompanyName}</div>
			</FormItem>
			<FormItem label="收款开户行">
				<div>{closing.toBankOpen}</div>
			</FormItem>
			<FormItem label="收款账号">
				<div>{closing.toBankNumber}</div>
			</FormItem>
			<FormItem label="付款开户行">
				<div>{closing.fromBankOpen}</div>
			</FormItem>
			<FormItem label="付款账号">
				<div>{closing.fromBankNumber}</div>
			</FormItem>
			<FormItem label="银行支付日期">
				{getFieldDecorator('payTime', {
						initialValue: moment(new Date(), dateFormat),
						rules: [{ required: true, message: '请输入银行支付日期' }]
				})(
						<DatePicker placeholder="请选择" />
				)}
			</FormItem>
			<FormItem label="付款凭证" >
				<div className="dragger-box" ref={draggerRef} style={{ position: 'relative' }}>
					<Dragger
						{...uploadFiles}
					>
						<p className="ant-upload-drag-icon">
							<Icon type="inbox" />
						</p>
						<p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
						<p className="ant-upload-hint">
							支持扩展名：.png, jpg, .pdf 单个文件大小不超过5M。
						</p>
					</Dragger>
				</div>
			</FormItem>
			<BtnGroup cancelName="取消" confirmName="确认" onConfirm={formSubmit} onCancel={() => setVisibleClosing(false)} />
		</Form>
	)
}

export default Form.create()(ClosingModal)